/**
 * Registers `/operations` with the ops router (`src/ops/routes/index.ts`'s
 * glob) -- the only file in this area anything outside it imports.
 */

import { createElement } from 'react';
import { SlidersHorizontal } from 'lucide-react';

import type { OpsRouteBundle } from '../routes/contract';
import { OpsShell } from '../shell/OpsShell';
import { Operations } from './Operations';
import { t } from './messages';

export const bundle: OpsRouteBundle = {
  order: 30,
  routes: [
    {
      path: '/operations',
      element: createElement(OpsShell, null, createElement(Operations)),
      kind: 'data',
    },
  ],
  nav: [
    { path: '/operations', label: () => t('nav.label'), icon: SlidersHorizontal, kind: 'data' },
  ],
};
